import React from 'react';

export const InputControl = () => {
  return <div>InputControl</div>;
};
